import { LoginForm } from '@/components/auth/LoginForm';

/**
 * Login Page (Platform-UI)
 *
 * Renders the authentication form for customer-facing platform access.
 *
 * Route: /login
 *
 * Behavior:
 * - Show email/password form
 * - Redirect to /fdaia on successful authentication
 * - Handle auth errors gracefully
 */

export default function LoginPage() {
  return <LoginForm />;
}
